module.exports = __webpack_public_path__ + "static/media/icon_weizhi.9e531862.svg";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/pageUrlSec/icon_weizhi.svg
// module id = 567
// module chunks = 0